import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Box,
  Chip,
  CircularProgress,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SmartToyIcon from "@mui/icons-material/SmartToy";
const lucy = require("../../../helpers/lucy_service");

const num = (n) => (n == null ? "0" : Number(n).toLocaleString("es-GT"));

const Stat = ({ label, value, sub }) => (
  <Grid item xs={6} md={3}>
    <Card variant="outlined">
      <CardContent sx={{ py: 1.5 }}>
        <Typography variant="overline" color="text.secondary">
          {label}
        </Typography>
        <Typography variant="h5">{value}</Typography>
        {sub && (
          <Typography variant="caption" color="text.secondary">
            {sub}
          </Typography>
        )}
      </CardContent>
    </Card>
  </Grid>
);

const LucyGlobalStats = () => {
  const [loading, setLoading] = useState(true);
  const [g, setG] = useState(null);
  const [logins, setLogins] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const [s, l] = await Promise.all([
          lucy.getGlobalStats(),
          lucy.getLoginMetrics({ pageSize: 100 }).catch(() => null),
        ]);
        setG(s.data.response);
        setLogins((l && l.data.response.items) || []);
      } catch (e) {
        // silencioso: el panel es informativo
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading)
    return (
      <Box sx={{ py: 2 }}>
        <CircularProgress size={22} />
      </Box>
    );
  if (!g) return null;

  const today = g.today || {};
  const month = g.month || {};
  const tags = Object.entries(month.tagCounts || {}).sort((a, b) => b[1] - a[1]);

  // Logins agregados por dia
  const byDay = {};
  logins.forEach((e) => {
    const d = (e.ts || "").slice(0, 10);
    if (!d) return;
    byDay[d] = byDay[d] || { total: 0, users: new Set(), fail: 0 };
    byDay[d].total += 1;
    if (e.result === "fail") byDay[d].fail += 1;
    else byDay[d].users.add(e.userId);
  });
  const loginRows = Object.entries(byDay)
    .sort()
    .reverse()
    .slice(0, 14);

  return (
    <Card variant="outlined" sx={{ mb: 3 }}>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
          <SmartToyIcon color="primary" />
          <Typography variant="h5">Uso de IA institucional — estadísticas generales</Typography>
        </Box>
        <Grid container spacing={2}>
          <Stat label="Tokens hoy" value={num(today.tokens)} />
          <Stat
            label="Tokens este mes"
            value={num(month.tokens)}
            sub={month.costEstimateUsd ? `~US$ ${month.costEstimateUsd}` : null}
          />
          <Stat
            label="Usuarios activos"
            value={num(month.activeUsers7 || month.activeUsers)}
            sub="7 días"
          />
          <Stat label="Activos 30 días" value={num(month.activeUsers30)} />
          <Stat label="Conversaciones (mes)" value={num(month.conversations)} />
          <Stat label="Mensajes (mes)" value={num(month.messages)} />
          <Stat label="Solicitudes de tokens pendientes" value={num(month.pendingRequests)} />
          <Grid item xs={6} md={3}>
            <Card variant="outlined">
              <CardContent sx={{ py: 1.5 }}>
                <Typography variant="overline" color="text.secondary">
                  Temas del mes
                </Typography>
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5, mt: 0.5 }}>
                  {tags.slice(0, 6).map(([t, c]) => (
                    <Chip key={t} size="small" label={`${t} (${c})`} />
                  ))}
                  {!tags.length && (
                    <Typography variant="caption" color="text.secondary">
                      sin datos aún
                    </Typography>
                  )}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Accordion sx={{ mt: 2 }} disableGutters>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Inicios de sesión en Cognito</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box sx={{ overflowX: "auto" }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Día</TableCell>
                    <TableCell align="right">Inicios de sesión</TableCell>
                    <TableCell align="right">Usuarios únicos</TableCell>
                    <TableCell align="right">Fallidos</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {loginRows.map(([d, v]) => (
                    <TableRow key={d}>
                      <TableCell>{d}</TableCell>
                      <TableCell align="right">{v.total}</TableCell>
                      <TableCell align="right">{v.users.size}</TableCell>
                      <TableCell align="right">{v.fail}</TableCell>
                    </TableRow>
                  ))}
                  {!loginRows.length && (
                    <TableRow>
                      <TableCell colSpan={4} align="center">
                        Sin datos (se llenan con el trigger Post-Authentication)
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </Box>
          </AccordionDetails>
        </Accordion>
      </CardContent>
    </Card>
  );
};

export default LucyGlobalStats;
